import { render, staticRenderFns } from "./MiniWizardSticky.vue?vue&type=template&id=a39ee9dc"
import script from "./MiniWizardSticky.vue?vue&type=script&lang=js"
export * from "./MiniWizardSticky.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports